<template>
    <div class="favorite-sales-items">
        <!-- SALES ITEMS IS ARR - {{ favoriteSalesItems }} -->
        <div class="sale-item" v-for="(item, index) in favoriteSalesItems">
            <saleItem :salesArr="item" :saleItemIndex="index" :saleItemsParentPage="'promo'"></saleItem>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import saleItem from '@/components/sales-page/sale-item.vue'

    // import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'favorite-sales-items',
        props: ['favoriteSalesItems'],
        components: {
            saleItem,
            // svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                cardID: this.$route.name,
            }
        },
        computed: mapGetters({
            favoritePage: 'loadFavoritePage',
        }),
        methods: {
        },
        created () {
            
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/favorite-page/favorite-sales-items.scss';
    @import '@/styles/components/favorite-page/respond/favorite-sales-items-respond.scss';
</style>